'use server'

import { apiRequest, ApiResponse } from '../request'

export type WhatsappSessionStatus =
    | 'DISCONNECTED'
    | 'PENDING_QR'
    | 'CONNECTING'
    | 'CONNECTED'
    | 'LOGGED_OUT'

export interface WhatsappChannelStatus {
    departmentId: number
    status: WhatsappSessionStatus
    phoneNumber: string | null
    /** Data URL do QR corrente — só vem preenchido em PENDING_QR. */
    qrCode: string | null
    connectedAt: string | null
    lastError: string | null
}

export async function getWhatsappSessionStatus(
    departmentId: number
): Promise<ApiResponse<WhatsappChannelStatus>> {
    return apiRequest<WhatsappChannelStatus>(
        `whatsapp/sessions/${departmentId}`,
        {}
    )
}

export async function connectWhatsappSession(
    departmentId: number
): Promise<ApiResponse<WhatsappChannelStatus>> {
    return apiRequest<WhatsappChannelStatus>(
        `whatsapp/sessions/${departmentId}/connect`,
        {},
        'post'
    )
}

export async function logoutWhatsappSession(
    departmentId: number
): Promise<ApiResponse<WhatsappChannelStatus>> {
    return apiRequest<WhatsappChannelStatus>(
        `whatsapp/sessions/${departmentId}/logout`,
        {},
        'post'
    )
}

